import { trackUiAppId } from '../config/track-config';
import { authService } from '../store/customer/utils/auth0.util';
import { messageExchangeConfig, postMxMessage, readMxMessage } from './message-exchange.utils';

const loginConfig = {
  forceLogin: true,
  prompt: 'login',
  maxAge: 0,
  caller: 'TRACK',
  product: 'MYPOST_CONSUMER',
  channel: 'WEB',
};

export const loginAndReturn = async (redirectUrl = '/mypost/track/search') => {
  if (!authService) return null;
  readMxMessage(messageExchangeConfig.redirectFromLogin);
  postMxMessage(messageExchangeConfig.redirectFromLogin, { redirectUrl }, trackUiAppId, 600000); // Arbitary 10min timeout for msg to expire
  // uiim login
  return await authService.login(loginConfig).catch(async (err) => {
    if (
      (err.message && err.message === 'reauth-required') ||
      (err.error_description && err.error_description === 'Reauth required') ||
      (err.isReauthRequiredError && err.isReauthRequiredError())
    ) {
      await authService?.login(loginConfig);
    }
  });
};
